import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "漫画库", to: "/fenlei" },
  { label: "人气排行", to: "/paihang" },
  { label: "关于我们", to: "/guanyu" },
  { label: "联系我们", to: "/lianxi" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (kw) {
      navigate(`/fenlei?q=${encodeURIComponent(kw)}`);
      setKeyword("");
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70 shadow-soft"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 md:h-[72px] items-center justify-between gap-4">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 shrink-0" aria-label="策驰漫画网首页">
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-book-open-fill text-lg md:text-xl"></i>
            </span>
            <span className="font-heading text-xl md:text-2xl text-primary-700 whitespace-nowrap">
              策驰漫画网
            </span>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((l) => {
              const active = l.to === "/" ? location.pathname === "/" : location.pathname.startsWith(l.to);
              return (
                <Link
                  key={l.to}
                  to={l.to}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                    active
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-primary-100/60"
                  }`}
                >
                  {l.label}
                </Link>
              );
            })}
          </nav>

          {/* Search */}
          <form onSubmit={handleSearch} className="hidden md:flex items-center flex-1 max-w-xs justify-end">
            <div className="relative w-full max-w-[220px]">
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画..."
                aria-label="搜索漫画"
                className="w-full h-10 pl-10 pr-4 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200 transition"
              />
              <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </form>

          {/* Mobile toggle */}
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            className="lg:hidden w-10 h-10 rounded-lg bg-background-100 border border-background-200 flex items-center justify-center text-foreground-700"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50/95 backdrop-blur-md">
          <div className="px-4 py-4 space-y-1">
            <form onSubmit={handleSearch} className="relative mb-3 md:hidden">
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画..."
                aria-label="搜索漫画"
                className="w-full h-11 pl-10 pr-4 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-800 outline-none focus:border-primary-400"
              />
              <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </form>
            {navLinks.map((l) => {
              const active = l.to === "/" ? location.pathname === "/" : location.pathname.startsWith(l.to);
              return (
                <Link
                  key={l.to}
                  to={l.to}
                  className={`block px-4 py-3 rounded-lg text-sm font-medium ${
                    active ? "bg-primary-500 text-background-50" : "text-foreground-700"
                  }`}
                >
                  {l.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </header>
  );
}